import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=2261c7d0&scoped=true&"
import script from "./addAndEdit.vue?vue&type=script&lang=js&"
export * from "./addAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./addAndEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addAndEdit.vue?vue&type=style&index=1&id=2261c7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2261c7d0",
  null
  
)

export default component.exports